import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useUtag } from 'Shared/hooks';
import { getClickUtagData } from 'Shared/utils';
import { ELevelResult } from 'Shared/types';
import NavigationButton from 'Common/components/NavigationButton/NavigationButton';
import useRouter from 'Router/index';
import { PhenotypeViewRoute, QQViewRoute } from 'Router/consts';
import { useValidatedPhenotypeId } from 'PhenotypeView/hooks';
import { getSelectors, getPhenotype } from 'PhenotypeView/store/selectors';
import { getSelectedDataset } from 'Datasets/store';
import { TEALIUM_EVENT } from 'Types/analytics';
import { QQ_PLOT_BUTTON_ID, DEFAULT_INFO_ICON_TITLE, getUnavailableDatasetMessage, } from './consts';
const utagData = getClickUtagData({ tealiumEvent: TEALIUM_EVENT.PHENOTYPE_VIEW_QQ_PLOT });
const QQPlotButtonContainer = ({ className, }) => {
    var _a;
    const utag = useUtag();
    const { name: phenotypeName } = useSelector(getPhenotype);
    const selectedDataset = (_a = useSelector(getSelectedDataset)) === null || _a === void 0 ? void 0 : _a.name;
    const { getParams, navigateTo } = useRouter();
    const { encodedPhenotypeName, datasetVersionId, levelResult = ELevelResult.Gene, } = getParams();
    const validatedPhenotypeId = useValidatedPhenotypeId();
    const { getFilters } = getSelectors(levelResult);
    const { collapsingModels } = useSelector(getFilters);
    const referrerURI = PhenotypeViewRoute.getPath({
        phenotypeId: validatedPhenotypeId,
        encodedPhenotypeName,
        datasetVersionId,
        levelResult,
    });
    const isAvailableDataset = !!selectedDataset
        && ALLOWED_DATASETS.QQ_VIEW_AVAILABLE_DATASETS.includes(selectedDataset);
    const isQQPlotButtonEnabled = collapsingModels.length === 1
        && isAvailableDataset;
    const infoTooltipText = isAvailableDataset
        ? DEFAULT_INFO_ICON_TITLE : getUnavailableDatasetMessage(selectedDataset);
    const onClick = useCallback(() => {
        if (isQQPlotButtonEnabled) {
            navigateTo(QQViewRoute, {
                encodedPhenotypeName,
                collapsingModelId: collapsingModels[0].id,
                datasetVersionId,
                levelResult,
            }, referrerURI, { name: `phenotype '${phenotypeName}'`, phenotypeId: validatedPhenotypeId });
            utag.link(utagData);
        }
    }, [
        utag,
        isQQPlotButtonEnabled,
        collapsingModels,
        datasetVersionId,
        levelResult,
        validatedPhenotypeId,
        encodedPhenotypeName,
        phenotypeName,
        referrerURI,
        navigateTo,
    ]);
    return (_jsx(NavigationButton, { className: className, enable: isQQPlotButtonEnabled, onClick: onClick, text: "See QQ Plot", id: QQ_PLOT_BUTTON_ID, testId: "QQPlotBtn", infoIconText: infoTooltipText }, void 0));
};
export default memo(QQPlotButtonContainer);
